<template>
	<main :data-test="$route.path">
		<header>
			<pageHeader1image v-bind="pageContent.pageHeader">
				<inputSearchHelp class="w-full max-w-375" />
				<searchHelpSuggestions />
			</pageHeader1image>
		</header>

		<div class="py-16 tablet:py-48 desktop:py-56 space-y-56 tabletWide:space-y-112">
			<LazyHydrate when-visible>
				<layoutSection class="tabletWide:-mb-56">
					<cantFindWhatYouAreLookingFor class="p-16 tablet:p-0 text-center" />
				</layoutSection>
			</LazyHydrate>

			<LazyHydrate when-visible>
				<layoutSection class="p-16 tablet:p-0">
					<faqList :faqs="pageContent.faqs" />
				</layoutSection>
			</LazyHydrate>
		</div>
	</main>
</template>

<script>
import cantFindWhatYouAreLookingFor from '~/components/cantFindWhatYouAreLookingFor.vue'
import layoutSection from '~/components/layoutSection.vue'
import { getSchemaFaqPage } from '~/assets/scripts/utilities/getStructuredData'
import { getPageMetaData } from '~/assets/scripts/utilities/getPageMetaData'

export default {
	components: {
		layoutSection,
		cantFindWhatYouAreLookingFor,
		faqList: () => import("~/components/faqList.vue"),
		pageHeader1image: () => import("~/components/pageHeader1image.vue"),
		inputSearchHelp: () => import("~/components/inputSearchHelp.vue"),
		searchHelpSuggestions: () => import("~/components/searchHelpSuggestions.vue"),
	},
	async asyncData(context) {
		const { slug } = context.route.params

		const [pageMetaData, pageContent, faqs] = await Promise.all([
			getPageMetaData(context.$strapi, `${slug}_faq`),
			import("~/static/data/helpPages").then(({ helpPages }) => helpPages.find((page) => page.slug === slug)),
			import("~/static/data/faq").then(({ faqs }) => faqs.filter((faq) => faq.section === slug)),
		])

		if (!pageContent || !faqs) {
			context.redirect("/help/")
			return
		}

		const { title, description } = pageMetaData ?? pageContent.metaInfo
		const pageMeta = {
			title,
			description
		}

		pageContent.faqs = faqs
		pageContent.structuredData = {
			faqPage: getSchemaFaqPage(faqs),
		}

		return {
			pageMeta,
			pageContent
		}
	},
	metaInfo() {
		return {
			title: this.pageMeta.title,
			meta: [
				{
					vmid: "description",
					name: "description",
					content: this.pageMeta.description,
				},
				{ vmid: "ogtitle", property: "og:title", content: this.pageMeta.title },
				{ vmid: "ogurl", property: "og:url", content: this.pageContent.metaInfo.url },
			],
			link: [{ rel: "canonical", href: this.pageContent.metaInfo.canonical }],
			script: [
				{
					type: "application/ld+json",
					json: this.pageContent.structuredData.faqPage,
				},
			],
		}
	},
}
</script>
